import React from "react";
import "../../../styles/footer.css";

export default function Footer(props) {
  return (
    <div className="footer-container">
      <div className="footer-info">
        {/* <p className="policy-disclaimer">Policy | Disclaimer </p> */}
        <p className="font-13">
         {/* All rights reserved. 
         PwC refers to India member firm and may sometimes refer to the PwC network. 
          Each member firm is a separate legal entity. Please see www.pwc.com/structure for further details. */}
          
          </p>
      </div>
    </div>
  );
}
